import { type SimpleShowRes } from '@on3/api';
import { useSite } from '@on3/ui-lib/index';
import { slugify } from '@on3/ui-lib/utils/slugify';
import { On3Avatar } from 'components/Image/On3Avatar';
import Link from 'next/link';

import styles from './ShowsItem.module.scss';

interface IShowsItemProps {
  item: SimpleShowRes;
}
export const ShowsItem = ({ item }: IShowsItemProps) => {
  // TODO: this still works. but let's look at refactoring to not use siteUrls.
  const { siteUrls } = useSite();

  const slug = slugify(item?.name);
  const url = siteUrls?.find((site) => site.key === item.siteKey)?.url;
  const teamUrl = (url || '/').replace(/\/$/, '');

  return (
    <li className={styles.block}>
      <Link
        className={styles.inner}
        href={`${teamUrl}/shows/${slug}-${item?.key}/`}
      >
        {item?.asset && (
          <div className={styles.avatar}>
            <On3Avatar
              className={styles.image}
              domain={item?.asset?.domain}
              height={100}
              source={item?.asset?.source}
              teamAvatar
              width={100}
            />
          </div>
        )}
        <div className={styles.meta}>
          <h3>
            <span className={styles.name}>{item?.name}</span>
            <span className={styles.subText}>Podcast</span>
          </h3>
        </div>
      </Link>
    </li>
  );
};
